import { List } from 'immutable';
import { actions } from './actions';

import * as lib from './lib';

const initialState = new List();

export default function reducer(state = initialState, { type, value }) {
  switch (type) {
    case actions.QUEUE:
      return state.push(lib.newRequest(value));
    case actions.REMOVE:
      return state.filterNot(request => request.get('id') === value);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/requests/reducer.js